import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Mail, Facebook, Twitter, Instagram, Zap } from 'lucide-react';

const TopBar = ({ data = {} }) => {
    const navigate = useNavigate();
    
    return (
        <>
            {/* Top Info Bar */}
            <div className="bg-[#003366] text-white py-2 text-[10px] sm:text-[11px] font-bold uppercase tracking-wider relative z-[60]">
                <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
                    <div className="flex items-center space-x-6">
                        <span className="flex items-center space-x-1.5"><Phone size={14} className="text-amber-400" /> <span>{data.contact_phone || data.phone || '+91 98765 43210'}</span></span>
                        <span className="hidden sm:flex items-center space-x-1.5"><Mail size={14} className="text-amber-400" /> <span>{data.contact_email || data.email || 'admissions@aryasabhyata.edu.in'}</span></span>
                    </div>
                    <div className="flex items-center space-x-5">
                        <div className="hidden md:flex items-center space-x-3">
                            {data.footer_facebook && <a href={data.footer_facebook} target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors"><Facebook size={14} /></a>}
                            {data.footer_twitter && <a href={data.footer_twitter} target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors"><Twitter size={14} /></a>}
                            {data.footer_instagram && <a href={data.footer_instagram} target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors"><Instagram size={14} /></a>}
                        </div>
                        <span className="hidden sm:block border-l border-white/20 h-3 ml-2"></span>
                        <button onClick={() => navigate('/login')} className="bg-[#cc0000] px-3 py-1 rounded-sm hover:bg-white hover:text-[#cc0000] transition-all">FACULTY LOGIN</button>
                    </div>
                </div>
            </div>

            {/* News Ticker */}
            <div className="bg-amber-400 text-[#003366] py-1.5 overflow-hidden whitespace-nowrap relative z-50">
                <div className="flex animate-marquee font-black uppercase text-[10px] tracking-widest">
                    {(data.ticker_news || data.news || 'Admissions open for Engineering, Management, and Basic Science programs for the academic session 2026-27 | Arya Sabhyata Group Ranked #1 for Innovations in Technical Education | Placements 2025: Highest package of 1.2 Crore offered to our student').split('|').map((item, idx) => (
                        <span key={idx} className="mx-8 flex items-center">
                            <Zap size={14} className="mr-2" /> {item.trim()}
                        </span>
                    ))}
                    {/* Duplicate for seamless infinite scroll */}
                    {(data.ticker_news || data.news || 'Admissions open for Engineering, Management, and Basic Science programs for the academic session 2026-27 | Arya Sabhyata Group Ranked #1 for Innovations in Technical Education | Placements 2025: Highest package of 1.2 Crore offered to our student').split('|').map((item, idx) => (
                        <span key={`dup-${idx}`} className="mx-8 flex items-center">
                            <Zap size={14} className="mr-2" /> {item.trim()}
                        </span>
                    ))}
                </div>
            </div>
        </>
    );
};

export default TopBar;
